export const columns = (vm) =>{
  return [
      {
          width:50,
          headerAlign:"center",
          align:"center",
          type:'selection',
      },
      {
        prop: 'resourcesUrl',
        label: '产品图片',
        minWidth: '120',
        tooltip: true,
        render: (h, params) => {
            return h('div', {
                style: {
                    display: 'flex',
                    alignItem: 'center',
                }
            }, [
                h('img', {
                    attrs: {
                        src: params.row.resourcesUrl,
                        width: '32',
                        height: '32',
                    },
                })
            ]);
        }
    },
      {
          label:'产品名称',
          prop:'productName',
          align:'center',
          headerAlign:'center',
          tooltip:true,
      },
      {
          label:'序列号/IMEI',
          prop:'serialNo',
          align:'center',
          headerAlign:'center',
      },
      {
          label:'安装位置',
          prop:'address',
          align:'center',
          headerAlign:'center',
          width:300,
      },
      {
          label:'安装时间',
          prop:'bindingTime',
          align:'center',
          headerAlign:'center',
          width:300,
      },
      {
          label:'到期时间',
          width:160,
          prop:'expirationTime',
          align:"center",
          headerAlign:"center"
      },
      {
        label:'状态',
        width:160,
        prop:'hasBingding',
        align:"center",
        headerAlign:"center",
        render:(h,param)=>{
          let txt = '';
          let color = ''
          color = param.row.hasBingding == 1?'rgb(159, 211, 157)':'rgb(245, 108, 108)';
          txt = param.row.hasBingding == 1?'启用':'禁用';
          return h('div',{style:{color:color}},txt);
        }
    }
      // {
      //     label:'操作',
      //     width:120,
      //     align:"center",
      //     headerAlign:"center",
      //     render: (h, params) => {
      //         let del = (h)=>{
      //             return h('el-button',{
      //                 props:{
      //                     type:'text'
      //                 },
      //                 style:{
      //                     padding:0
      //                 },
      //                 on:{
      //                     click:()=>{vm.operateShow(2,params.row)}
      //                 }
      //             },'删除')
      //         }

      //         let query = (h)=>{
      //             return h('el-button',{
      //                 props:{
      //                     type:'text'
      //                 },
      //                 style:{
      //                     padding:0
      //                 },
      //                 on:{
      //                     click:()=>{vm.operateShow(1,params.row)}
      //                 }
      //             },'查看')
      //         }

      //         let btnArr = [];
      //         btnArr.push(query(h));
      //         btnArr.push(del(h));

      //         return h('div',{},btnArr)
      //     }
      // }
    ]
}